export enum EEventsUrls {
  EVENTS = 'event-app',
  EVENT = 'event-event',
  REGISTRATION = 'registration',
  EVENT_CITIES = 'event-event/location/cities',
  PARENT_ORDERING = 'parent-ordering',
  SHIPPING_DETAILS = 'shipping-details',
  VALIDATE = 'validate',
  SUBSCRIBE = 'subscribe',
  IDAHO = 'idaho',
  CITIES = 'cities',
  FREE_SLOT = 'free-slot',
  FORM = 'form',
  MEETING_LINK = 'meeting-link',
  LIGHT_BOX = 'lightbox',
}

export const meetingLinkUrl = `${EEventsUrls.EVENTS}/${EEventsUrls.EVENT}/${EEventsUrls.MEETING_LINK}`;
export const getRegistrationModalDataUrl = `${EEventsUrls.EVENTS}/${EEventsUrls.REGISTRATION}/${EEventsUrls.FORM}`;
export const getRegistrationFreeSlotsUrl = `${EEventsUrls.EVENTS}/${EEventsUrls.REGISTRATION}/${EEventsUrls.FREE_SLOT}`;
